import { render, staticRenderFns } from "./StorageRequest.vue?vue&type=template&id=e25f5ede&scoped=true"
import script from "./StorageRequest.vue?vue&type=script&lang=js"
export * from "./StorageRequest.vue?vue&type=script&lang=js"
import style0 from "./StorageRequest.vue?vue&type=style&index=0&id=e25f5ede&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e25f5ede",
  null
  
)

export default component.exports